export default __webpack_public_path__ + "static/media/4_tutorial_batch_processing.7a5394af.png";